const Crosshair = ({ coordinates }) => {
    return (
      <div
        className="rounded-full absolute bg-white opacity-40  border-black border-4 border-dashed w-10 h-10 md:w-20 md:h-20 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center"
        style={coordinates}
      >
        <span className="w-2 h-2 bg-red-600 rounded-full"></span>
      </div>
    );
  };
  export default Crosshair;